import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useLang, tr } from "../contexts/LangContext";
import { withLang } from "../components/SeoHead";
import api from "../lib/api";
import { ArrowLeft, X } from "lucide-react";

export default function GalleryAlbum() {
  const { slug } = useParams();
  const { t, lang } = useLang();
  const [album, setAlbum] = useState(null);
  const [lightbox, setLightbox] = useState(null); // photo

  useEffect(() => {
    api.get(`/gallery/albums/${slug}`).then((r) => setAlbum(r.data)).catch(() => setAlbum(false));
  }, [slug]);

  if (album === false) return (
    <div className="pt-32 pb-20 text-center" data-testid="album-not-found">
      <h2 className="font-serif text-2xl text-navy mb-4">Album introuvable</h2>
      <Link to={withLang(lang, "/galerie")} className="text-club-red hover:underline">← Retour à la galerie</Link>
    </div>
  );
  if (!album) return <div className="pt-32 text-center text-slate-500">{t.common.loading}</div>;

  const backend = process.env.REACT_APP_BACKEND_URL;
  const fullUrl = (u) => (u && u.startsWith("/uploads/") ? `${backend}/api${u}` : u);

  return (
    <div className="pt-24 md:pt-28 pb-20 min-h-screen bg-sand" data-testid="album-page">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <Link to={withLang(lang, "/galerie")} className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-slate-500 hover:text-navy mb-6" data-testid="album-back">
          <ArrowLeft className="w-3 h-3" /> Retour à la galerie
        </Link>
        <div className="text-[10px] uppercase tracking-[0.25em] text-club-yellow-dark font-semibold mb-2">
          {album.year}{album.date && ` · ${new Date(album.date).toLocaleDateString(lang === "en" ? "en-GB" : lang)}`}
        </div>
        <h1 className="font-serif text-4xl text-navy">{album.title}</h1>
        <div className="divider-gold mt-4 mb-6" />
        {album.description && <p className="text-slate-600 mb-10 max-w-3xl">{album.description}</p>}

        {(album.photos || []).length === 0 ? (
          <div className="bg-white border border-dashed border-slate-300 py-16 text-center text-slate-500" data-testid="album-empty">{tr("Aucune photo dans cet album.")}</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {album.photos.map((p) => (
              <button key={p.id} onClick={() => setLightbox(p)} className="group block aspect-square overflow-hidden bg-white border border-slate-200 hover:border-club-red"
                data-testid={`album-photo-${p.id}`}>
                <img src={fullUrl(p.url)} alt={p.caption || album.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </button>
            ))}
          </div>
        )}
      </div>

      {lightbox && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4" onClick={() => setLightbox(null)} data-testid="album-lightbox">
          <button className="absolute top-4 right-4 text-white hover:opacity-70" onClick={() => setLightbox(null)} data-testid="album-lightbox-close">
            <X className="w-8 h-8" />
          </button>
          <img src={fullUrl(lightbox.url)} alt={lightbox.caption || album.title} className="max-h-[90vh] max-w-[90vw] object-contain" onClick={(e) => e.stopPropagation()} />
          {lightbox.caption && (
            <div className="absolute bottom-4 left-0 right-0 text-center text-white text-sm">{lightbox.caption}</div>
          )}
        </div>
      )}
    </div>
  );
}
